import { render, staticRenderFns } from "./Yardages-list.vue?vue&type=template&id=c5d91d9a&lang=html"
import script from "./Yardages-list.vue?vue&type=script&lang=js"
export * from "./Yardages-list.vue?vue&type=script&lang=js"
import style0 from "./Yardages-list.vue?vue&type=style&index=0&id=c5d91d9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports